// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ApprovableContainer } from "@modules/service/types";
import type { RtwStateType, Rtw } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

//Live Processes

export const onDisableRtw = (state: RtwStateType) => () => startRequest(state);
export const onDisableRtwSuccess = (state: RtwStateType) => () => finishRequest(state);
export const onDisableRtwError = (state: RtwStateType) => () => finishRequest(state);

export const onAddRtw = (state: RtwStateType) => () => startRequest(state);
export const onAddRtwSuccess = (state: RtwStateType) => () => finishRequest(state);
export const onAddRtwError = (state: RtwStateType) => () => finishRequest(state);

export const onSetRTWLiveProcessesFilter = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  liveProcessesFilter: payload,
});

export const onGetRTWLiveProcesses = (state: RtwStateType) => () => startRequest(state);

export const onGetRTWLiveProcessesSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  liveProcesses: payload,
});

export const onGetRTWLiveProcessesError = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

//Pending Processes
export const onGetRTWPendingProcesses = (state: RtwStateType) => () => startRequest(state);
export const onGetRTWPendingProcessesSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  pendingProcesses: payload,
});
export const onGetRTWPendingProcessesError = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

//Draft Processes
export const onGetRTWDraftProcesses = (state: RtwStateType) => () => startRequest(state);
export const onGetRTWDraftProcessesSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  draftProcesses: payload,
});
export const onGetRTWDraftProcessesError = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Record

export const onGet = (state: RtwStateType) => () => startRequest(state);

export const onGetSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetError = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Schema

export const onGetSchema = (state: RtwStateType) => () => startRequest(state);

export const onGetSchemaSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetSchemaError = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create

export const onNew = (state: RtwStateType) => (action: Action<void>) => ({
  ...state,
  draft: {},
});

export const onStartDraftSuccess = (state: RtwStateType) => ({
  payload,
}: Action<ApprovableContainer<Rtw>>) => ({
  ...state,
  draft: (payload && payload.active) || {},
});

export const onDuplicateSuccess = (state: RtwStateType) => ({ payload }: Action<Rtw>) => ({
  ...state,
  draft: payload,
});

export const onSetDraft = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  draft: payload,
});

export const onNewAssignments = (state: RtwStateType) => (action: Action<void>) => ({
  ...state,
  assignments: [],
});

export const onSetAssignments = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  assignments: payload,
});

export const onSetRtwDraftAssignments = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  draftAssignments: payload,
});

// Config

export const onSetEnabled = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    enabled: payload,
  },
});

export const onSetStatus = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    status: payload,
  },
});

// Modals

export const onSetModalStep = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    modalStep: payload,
  },
});

export const onSetShowAddModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowEditAssignmentsModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditAssignmentsModal: payload,
  },
});

export const onSetShowDiscardModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDiscardModal: payload,
  },
});

export const onSetShowSubmitModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showSubmitModal: payload,
  },
});

export const onSetShowCancelModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelModal: payload,
  },
});

export const onSetShowCancelDiscardModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelDiscardModal: payload,
  },
});

export const onSetShowDisableModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDisableModal: payload,
  },
});

export const onSetShowAddRtwAttachmentModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddRtwAttachmentModal: payload,
  },
});
export const onUpdateRtw = (state: RtwStateType) => () => startRequest(state);
export const onUpdateRtwSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  current: {
    ...state.current,
    active: payload,
  },
});
export const onUpdateRtwError = (state: RtwStateType) => () => finishRequest(state);

type OnChangeAddFileInProgressPayload = {
  addFileInProgress: any,
};
export const onChangeAddFileInProgress = (state: RtwStateType) => (
  action: Action<OnChangeAddFileInProgressPayload>,
) => {
  const { addFileInProgress } = action.payload || {};

  return {
    ...state,
    addFileInProgress,
  };
};
